import { createSelector } from 'reselect';
import getFP from 'lodash/fp/get';

import { getFormSyncErrors, getFormAsyncErrors, formValueSelector } from 'redux-form';

const getCardSuggests = getFP('common.cardSuggests');

const formName = 'PayForm';
const selector = formValueSelector(formName);
const saveCardSelector = (state) => selector(state, 'saveCard');

export const payCardSelector = createSelector(
  getCardSuggests,
  getFormSyncErrors(formName),
  getFormAsyncErrors(formName),
  saveCardSelector,
  (cardSuggests, syncErrors, asyncErrors, saveCard) => ({
    errors: { ...syncErrors, ...asyncErrors },
    saveCardFieldValue: saveCard,
    paymentCardInfo: cardSuggests,
  })
);
